import { isClientSide } from "@/lib/is-client-side"

interface IOSAppBannerMetaProps {
  appArgument?: string
}

const IOS_APP_ID = 6503107567

export function IOSAppBannerMeta({ appArgument }: IOSAppBannerMetaProps) {
  if (!isClientSide() || !/iPhone/.test(navigator.userAgent)) return null

  const content = appArgument
    ? `app-id=${IOS_APP_ID}, app-argument=${appArgument}`
    : `app-id=${IOS_APP_ID}`

  return <meta name="apple-itunes-app" content={content} />
}
